export default __webpack_public_path__ + "static/media/3.2a641f5f.jpg";